import AsyncStorage from '@react-native-async-storage/async-storage';

import { logger } from '@lib/logger';

type LocaleStorageParams = {
  deviceId: string;
  accessToken: string;
  refreshToken: string;
  firebaseCustomToken: string;
};

export async function setData<K extends keyof LocaleStorageParams>(
  key: K,
  value: LocaleStorageParams[K],
): Promise<void> {
  try {
    return AsyncStorage.setItem(key, value);
  } catch (e) {
    logger.error('Error setting data into local storage', e);
  }
}

export async function getData<K extends keyof LocaleStorageParams>(
  key: K,
): Promise<LocaleStorageParams[K] | null> {
  try {
    return AsyncStorage.getItem(key);
  } catch (e) {
    logger.error('Error getting data from local storage', e);
    return null;
  }
}

export async function removeData<K extends keyof LocaleStorageParams>(
  key: K,
): Promise<void> {
  try {
    return AsyncStorage.removeItem(key);
  } catch (e) {
    logger.error('Error removing data from local storage', e);
  }
}
